// Selettore del periodo di Scadenziario e Parcellazione: Mese, Anno e "Tutte le pratiche dell'anno".
// `mese` è AAAA-MM; con `tuttiMesi` conta solo l'anno. Lo stile è in pages/competenze/competenze.css.
export const MESI = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

// Anni scelti dal 2022 fino all'anno prossimo (più l'anno attualmente mostrato, se fuori intervallo)
export function anniElenco(corrente) {
  const fine = new Date().getFullYear() + 1;
  const anni = [];
  for (let a = 2022; a <= fine; a++) anni.push(String(a));
  if (!anni.includes(corrente)) anni.push(corrente);
  return anni.sort();
}

export default function SelettorePeriodo({ mese, tuttiMesi, onMese, onTuttiMesi, descrizione = 'pratiche' }) {
  return (
    <div className="periodoScad">
      <select className="selPeriodo" aria-label="Mese" value={mese.slice(5, 7)} disabled={tuttiMesi}
        onChange={e => onMese(`${mese.slice(0, 4)}-${e.target.value}`)}>
        {MESI.map((n, k) => <option key={n} value={String(k + 1).padStart(2, '0')}>{n}</option>)}
      </select>
      <select className="selPeriodo" aria-label="Anno" value={mese.slice(0, 4)}
        onChange={e => onMese(`${e.target.value}-${mese.slice(5, 7)}`)}>
        {anniElenco(mese.slice(0, 4)).map(a => <option key={a} value={a}>{a}</option>)}
      </select>
      <label className={`chkAnno ${tuttiMesi ? 'chkAnnoAttivo' : ''}`} title={`Mostra tutte le ${descrizione} dell'anno scelto`}>
        <input type="checkbox" checked={tuttiMesi} onChange={e => onTuttiMesi(e.target.checked)} /> Tutte le pratiche dell'anno
      </label>
    </div>
  );
}
